import type {Schemas} from 'api/dto.generated';
import {ebsApi} from 'store/ebsApi';
import type {ChangeRequest} from './types';
import {loadAllChangeRequestsForWork} from './localStorage';
import {mapManualApprovalChangeRequestsDto} from './mappers';

export const changeRequestsApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getChangeRequests: build.query<
      ChangeRequest[],
      {workId: string; eans: string[]},
      Schemas.ManualApprovalChangeRequestsDto
    >({
      query: ({eans}) =>
        `manualapproval/changerequest/ean?ean=${eans.join(',')}`,
      transformResponse: (response, _, arg) => {
        const backendCRs = mapManualApprovalChangeRequestsDto(
          arg.workId,
          response,
        );
        const localCRs = loadAllChangeRequestsForWork(arg.workId);
        return [...backendCRs, ...localCRs];
      },
    }),
    postChangeRequestClose: build.mutation<void, string>({
      query: refId => ({
        url: `manualapproval/changerequest/${refId}/resolve`,
        method: 'POST',
      }),
    }),
  }),
});

export const {useGetChangeRequestsQuery, usePostChangeRequestCloseMutation} =
  changeRequestsApi;
